var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueDiamond({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8044 5.52548L20.2732 1.28812C20.1128 1.09566 19.8752 0.984375 19.6247 0.984375H4.37541C4.12482 0.984375 3.8873 1.09566 3.72685 1.28812L0.195669 5.52548C-0.0591433 5.83124 -0.0657527 6.27346 0.179778 6.58672L11.3356 20.8199C11.6736 21.2512 12.3265 21.2512 12.6645 20.8199L23.8203 6.58668C24.0657 6.27341 24.0591 5.83124 23.8044 5.52548Z",
    fill: "#00C3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0023 0.984375L7.78125 6.04968H16.2234L12.0023 0.984375Z",
    fill: "#40D2FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.77819 6.0464L4.03438 1.05469C3.91673 1.10662 3.81041 1.18364 3.72609 1.28484L0.194906 5.52219C0.0683436 5.67412 0.00365624 5.85965 0 6.0464H7.77819Z",
    fill: "#00AAF0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2188 6.0464L19.9625 1.05469C20.0802 1.10662 20.1865 1.18364 20.2708 1.28484L23.8019 5.52219C23.9285 5.67412 23.9932 5.85965 23.9968 6.0464H16.2188Z",
    fill: "#80E1FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9987 6.04688H0.000159697C-0.00349655 6.23597 0.0556127 6.42623 0.179175 6.58392L11.335 20.8171C11.673 21.2484 12.3259 21.2484 12.6639 20.8171L23.8197 6.58387C23.9432 6.42623 24.0022 6.23597 23.9987 6.04688Z",
    fill: "#00C3FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.1406C12.2477 21.1406 12.4955 21.0328 12.6645 20.8172L23.8203 6.58392C23.9438 6.42628 24.0029 6.23602 23.9993 6.04688H12V21.1406Z",
    fill: "#00C3FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3671 21.0777C12.6393 20.0706 16.4422 6 16.4422 6H8L12.075 21.0777C12.1719 21.0946 12.2704 21.0946 12.3671 21.0777Z",
    fill: "#00AAF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueDiamond);
export default __webpack_public_path__ + "static/media/blue_diamond.7a79ecd634831fd8c01f1d07af9a3912.svg";
export { ForwardRef as ReactComponent };